import { createReducer } from '@reduxjs/toolkit';

import * as actionTypes from '../../actionTypes';

/** @typedef {boolean} IsCookieModalOpenState */

/** @type {IsCookieModalOpenState} */
const initialState = false;

const open = () => true;
const close = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.OPEN_COOKIE_MODAL, open)
    .addCase(actionTypes.CLOSE_COOKIE_MODAL, close);
});
